import { Action } from './action';
import { BaseRequest, getRequestType, RequestClass } from 'acscp/api/requests';
import { ResponseErrorTypes, ResponseType } from 'acscp/api/responses';
import { ErrorDetails } from 'acscp/api/models/errorDetails';
import { ErrorMessage } from 'acscp/api/models/errorMessage';

export class FetchRequest<P> extends Action {
    constructor(public request: BaseRequest<P>, public callerId?: string) {
        super(`${FetchRequest.name}.${getRequestType(request)}`);
    }
}

export class FetchSuccess<TResponse extends any|undefined, TRequest extends BaseRequest<TResponse>> extends Action {
    constructor(public request: TRequest, public response: TResponse, public callerId?: string) {
        super(`${FetchSuccess.name}.${getRequestType(request)}`);
    }
}

export class FetchError<TRequest extends BaseRequest<any>> extends Action {
    constructor(public request: TRequest,
                public responseType: ResponseErrorTypes,
                public error: ErrorDetails,
                public callerId?: string) {
        super(`${FetchError.name}.${getRequestType(request)}`);
    }
}

export class FetchFatalError extends Action {
    constructor(public request: BaseRequest<any>,
                public message: ErrorMessage,
                public callerId?: string) {
        super(`${FetchFatalError.name}.${getRequestType(request)}`);
    }
}

export class FetchResetStatus extends Action {
    requestToResetKey: string;
    constructor(requestClass: RequestClass<any>, public callerId?: string) {
        super();
        this.requestToResetKey = getRequestType(requestClass);
    }
}

export interface FetchClass {
    new (...args: any[]): FetchSuccess<any, any> | FetchError<any> | FetchFatalError;
}

export function getFetchActionTypeForRequestClass(fetchClass: FetchClass, requestClass: RequestClass<any>): string {
    return `${fetchClass.name}.${getRequestType(requestClass)}`;
}
